import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { manageGroupsDialogImport, manageGroupsDialogImportSingle, manageGroupsDialogRemove } from '../../actions'

function mapStateToProps(state) {
    return {
        rows: state.getIn(['ui', 'manageGroups', 'rows']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            manageGroupsDialogImport,
            manageGroupsDialogImportSingle,
            manageGroupsDialogRemove,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
